<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tmtPKE/tc-custom/9781634868723.jpg?1718106103426" alt="This image is the cover for the book Getting Wade, Hot Flash"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Getting Wade, Hot Flash
      </h1>
      <p class="bookDescription body article font2">
        <p>Wade and Neal have always been friends. Just friends. They grew up together. Wade has always disliked Neal’s choice in boyfriends, though he never analyzes why, and when the latest turns out to be a cheating jerk, it’s Wade to the rescue.<br/><br/>Neal has always had a thing for his best friend, but Wade doesn’t show any interest in being anything <i>other</i> than friends. This time Neal thought he’d picked the perfect guy as a substitute for who he really wanted only to be proven wrong again.<br/><br/>When his best friend rescues him from a bad situation, Neal decides to take a chance to finally get Wade.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shawn Lane
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ec2b7b2c